export const uiSchema = (t, settings: Object) => {
  return {
    managementUsers: {
      "ui:order": [
        "*",
        "notificationAdmin",
        "excludeAbsencesFromAlerts",
        "allowManagerEditEmployeesShiftPattern",
      ],
      excludeAbsencesFromAlerts: {
        "ui:widget": "toggle",
        "ui:options": {
          labels: [
            { label: t("ACTIVE"), value: true },
            { label: t("INACTIVE"), value: false },
          ],
        },
      },
      allowManagerEditEmployeesShiftPattern: {
        "ui:widget": "toggle",
        "ui:options": {
          labels: [
            { label: t("ACTIVE"), value: true },
            { label: t("INACTIVE"), value: false },
          ],
        },
      },
      absenceMonitoringDetails: {
        "ui:widget": "hidden",
      },
      benchmarkingStatistics: {
        "ui:widget": "hidden",
      },
      closeAbsences: {
        "ui:widget": "hidden",
      },
      employeeAccounts: {
        "ui:widget": "hidden",
      },
      reportAbsences: {
        "ui:widget": "hidden",
      },
      updateAbsences: {
        "ui:widget": "hidden",
      },
      viewRtwForms: {
        "ui:widget": "hidden",
      },
      permittedExtension: {
        "ui:widget": "hidden",
      },
    },
    employeeUsers: {
      "ui:order": [
        "employeeAccounts",
        "benchmarkingStatistics",
        "absenceMonitoringDetails",
        "viewRtwForms",
        "*",
      ],
      employeeAccounts: {
        "ui:widget": "toggle",
        "ui:options": {
          labels: [
            { label: t("ACTIVE"), value: true },
            { label: t("INACTIVE"), value: false },
          ],
        },
      },
      benchmarkingStatistics: {
        "ui:widget": settings.employeeAccounts ? "toggle" : "hidden",
        "ui:options": {
          labels: [
            { label: t("ACTIVE"), value: true },
            { label: t("INACTIVE"), value: false },
          ],
        },
      },
      absenceMonitoringDetails: {
        "ui:widget": settings.employeeAccounts ? "toggle" : "hidden",
        "ui:options": {
          labels: [
            { label: t("ACTIVE"), value: true },
            { label: t("INACTIVE"), value: false },
          ],
        },
      },
      viewRtwForms: {
        "ui:widget": settings.employeeAccounts ? "toggle" : "hidden",
        "ui:options": {
          labels: [
            { label: t("ACTIVE"), value: true },
            { label: t("INACTIVE"), value: false },
          ],
        },
      },
      permittedExtension: {
        "ui:widget": "hidden",
      },
      notificationAdmin: {
        "ui:widget": "hidden",
      },
      excludeAbsencesFromAlerts: {
        "ui:widget": "hidden",
      },
      allowManagerEditEmployeesShiftPattern: {
        "ui:widget": "hidden",
      },
      reportAbsences: {
        "ui:widget": "hidden",
      },
      updateAbsences: {
        "ui:widget": "hidden",
      },
      closeAbsences: {
        "ui:widget": "hidden",
      },
    },
    absenceUpdatePermissions: {
      "ui:order": ["reportAbsences", "updateAbsences", "permittedExtension", "closeAbsences", "*"],
      reportAbsences: { "ui:widget": "select" },
      updateAbsences: { "ui:widget": "select" },
      permittedExtension: {
        "ui:widget": settings.updateAbsences === "NONE" ? "hidden" : "number-input",
      },
      closeAbsences: { "ui:widget": "select" },
      benchmarkingStatistics: {
        "ui:widget": "hidden",
      },
      absenceMonitoringDetails: {
        "ui:widget": "hidden",
      },
      viewRtwForms: {
        "ui:widget": "hidden",
      },
    },
  };
};
